import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, API } from "../lib/api";

const ContentContext = createContext(null);

export const photoUrl = (id) => `${API}/content/photo/${id}`;

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({ photos: [] });

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data || { photos: [] });
    } catch (e) {
      setContent({ photos: [] });
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <ContentContext.Provider value={{ content, reload }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
};
